package components.menus.sidebar

import mui.icons.material.Dashboard
import mui.icons.material.SvgIconComponent
import react.ReactNode

data class MenuItem(
    val title: String = "",
    val href: String? = "",
    val icon: SvgIconComponent = Dashboard,
    val element: ReactNode? = null,
    val logout: Boolean = false
)